import { Component, Input } from '@angular/core';

@Component({
  selector: 'ipm-equalizer-animation',
  templateUrl: './equalizer-animation.component.html',
  styleUrls: ['./equalizer-animation.component.scss']
})
export class EqualizerAnimationComponent {
  @Input({ required : false})  isShowHover : boolean = false;
}
